import ApiService from '@/core/connector/api.service';

export default class ValidateLandingServices extends ApiService {
  retrieveMobilePhones(uniqueId) {
    this.url = `sg/verification_codes/mobile_phones/${uniqueId}`;
    return this.get();
  }

  sendSms(uniqueId, payload) {
    this.payload = payload;
    this.url = `sg/verification_codes/sms/${uniqueId}`;
    return this.post();
  }

  verifySmsCode(uniqueId, payload) {
    this.payload = payload;
    this.url = `sg/verification_codes/check/${uniqueId}`;
    return this.post();
  }
}
